module.exports = __webpack_public_path__ + "img/57_17.278c60b3.png";